import { useNavigate } from 'react-router-dom';

export const useTokenExpiredHandler = () => {
  const navigate = useNavigate();
  const onTokenExpired = () => {
    navigate('/');
  };
  return onTokenExpired;
};
